<template>
    <div :class="[size ? `input-group-${size}` : 'input-group']">
        <span class="input-group-prepend" v-if="prependIsset"><slot name="prepend"></slot></span>
        <slot></slot>
        <span class="input-group-append" v-if="appendIsset"><slot name="append"></slot></span>
    </div>
</template>

<script>
export default {
    name: "InputGroup",
    props: {
        size: {
            type: String,
            default: null // lg, sm
        }
    },
    computed: {
        prependIsset() {
            return !!this.$slots.prepend;
        },
        appendIsset() {
            return !!this.$slots.append;
        },
    }
}
</script>

<style>
.input-group {
    display: flex;
    align-items: center;
}

.input-group > .select2,
.input-group > .autocomplete {
    position: relative;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1% !important;
    margin-bottom: 0;
}
</style>
